import { render, staticRenderFns } from "./WebsiteArticleList.vue?vue&type=template&id=bcbbdb58&scoped=true&"
import script from "./WebsiteArticleList.vue?vue&type=script&lang=js&"
export * from "./WebsiteArticleList.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteArticleList.vue?vue&type=style&index=0&id=bcbbdb58&scoped=true&lang=css&"
import style1 from "./WebsiteArticleList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbbdb58",
  null
  
)

export default component.exports